import React from 'react';
import './SpaceUpTwo.css';
import Header from '../Header/Header';
import SpaceUpTwoDisplay from '../../Components/SpaceUpTwoDisplay/SpaceUpTwoDisplay';

const SpaceUpTwo= () => {
    return (
        <div>
            <Header></Header>
            <SpaceUpTwoDisplay></SpaceUpTwoDisplay>
            
        </div>
    );
};

export default SpaceUpTwo;